module.exports = __webpack_public_path__ + "static/media/021.2ad93e52.jpg";